function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Rect, {
  fill: "#002459",
  width: 61,
  height: 61,
  rx: 10
});

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M27.206 21h19.895v1.944H27.206zm0 6.004h19.895v1.944H27.206zm0 6.004h19.895v1.944H27.206zm0 6.605h19.895v1.944H27.206z",
  fill: "#17bf88"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#17bf88",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement(Path, {
  d: "M20.348 24.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M22.348 31c0-2.209-2.015-4-4.5-4-2.486 0-4.5 1.791-4.5 4"
})));

function SvgIconViewMosaicRight(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconViewMosaicRight;